export enum ProfileTab {
    General = 'general',
    Settings = 'settings',
    AdditionalProfiles = 'additional-profiles',
}
